import config from 'config/config';

const getBaseUrl = () => {
  // @ts-ignore
  const storeBaseUrl = window?.storeBaseUrl;
  if (storeBaseUrl) {
    return storeBaseUrl;
  } else {
    return `${config.development ? 'conferdemostore.myshopify.com' : window.location.hostname.replace('www.', '')}`;
  }
};

export default { getBaseUrl };
